export default "__VITE_ASSET__VFRclpx___"